import React, { useMemo } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { pinOptions } from '../top-producer/helpers';
import SearchableSelect from './SearchableSelect';

export const scopeOptions = (options, scope) => {
  const atStore = person => !scope.salesLocation || (person.salesLocations || []).map(String).includes(scope.salesLocation);
  const managers = options.managers.filter(atStore);
  const manager = managers.find(person => String(person._id) === scope.salesManager);
  const team = manager && new Set([String(manager._id), ...(manager.reps || []).map(rep => String(rep._id))]);
  const reps = options.users.filter(person => atStore(person) && (!scope.salesManager || (team && team.has(String(person._id)))));
  return { managers, reps };
};

export default function SalesScopeFilters({ appChoices, value, onChange }) {
  const options = useMemo(() => pinOptions(appChoices), [appChoices]);
  const { managers, reps } = scopeOptions(options, value);
  const fields = [
    ['salesLocation', 'Sales location', options.stores, 'All accessible stores'],
    ['salesManager', 'Sales manager / team', managers, 'All teams'],
    ['salesperson', 'Sales rep', reps, value.salesManager ? 'Everyone on this team' : 'All reps']
  ];
  return <Row className="mt-2">
    {fields.map(([key, label, people, allLabel]) => {
      const choices = [{ value: '', label: allLabel },
        ...(key === 'salesperson' && !value.salesManager ? [{ value: 'unassigned', label: 'Unassigned' }] : []),
        ...people.map(person => ({ value: String(person._id), label: person.location || person.name }))];
      if (value[key] && !choices.some(option => option.value === value[key])) {
        choices.push({ value: value[key], label: 'Selected filter is unavailable — clear filters' });
      }
      return <Col xs={12} md={4} key={key}>
        <Form.Label htmlFor={'pipeline-' + key} className="small mb-1">{label}</Form.Label>
        <SearchableSelect size="sm" inputId={'pipeline-' + key} options={choices} value={value[key] || ''}
          noOptionsMessage={() => key === 'salesperson' && value.salesManager ? 'No matching rep on this team. Clear filters to search other permitted teams.' : 'No matches in your accessible records.'}
          onChange={selected => {
            const next = { ...value, [key]: selected };
            if (key === 'salesLocation') { next.salesManager = ''; next.salesperson = ''; }
            if (key === 'salesManager') next.salesperson = '';
            onChange(next);
          }} />
      </Col>;
    })}
    <Col xs={12} className="small text-muted mt-2">
      <span>Filters change this view only; they do not assign leads. {value.salesManager ? 'Rep choices include only the selected manager’s team.' : 'Clear filters to search all records your account can access.'}</span>
      {(value.salesLocation || value.salesManager || value.salesperson) && <Button type="button" variant="link" size="sm"
        onClick={() => onChange({ ...value, salesLocation: '', salesManager: '', salesperson: '' })}>Clear filters</Button>}
    </Col>
  </Row>;
}
